import { render } from "./BoardWriteModal.vue?vue&type=template&id=0438fe69&scoped=true&ts=true"
import script from "./BoardWriteModal.vue?vue&type=script&lang=ts"
export * from "./BoardWriteModal.vue?vue&type=script&lang=ts"

import "./BoardWriteModal.vue?vue&type=style&index=0&id=0438fe69&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0438fe69"]])

export default __exports__